import { AccountConfigModule } from '@abp/ng.account/config';
import { CoreModule } from '@abp/ng.core';
import { registerLocale } from '@abp/ng.core/locale';
import { IdentityConfigModule } from '@abp/ng.identity/config';
import { AbpOAuthModule } from '@abp/ng.oauth';
import { SettingManagementConfigModule } from '@abp/ng.setting-management/config';
import { TenantManagementConfigModule } from '@abp/ng.tenant-management/config';
import { ThemeLeptonXModule } from '@abp/ng.theme.lepton-x';
import { SideMenuLayoutModule } from '@abp/ng.theme.lepton-x/layouts';
import { ThemeSharedModule } from '@abp/ng.theme.shared';
import { NgModule, APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ServiceUnavailableComponent } from './shared/components/service-unavailable/service-unavailable.component';
import { BackendUnavailableErrorHandlerService } from './shared/services/backend-unavailable-error-handler.service';
import { CUSTOM_ERROR_HANDLERS } from '@abp/ng.theme.shared';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { APP_ROUTE_PROVIDER } from './route.provider';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { FormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AppMenuContributor } from './menu-contributor';
import { SharedModule } from './shared/shared.module';

// BREAKING: Removed APP_INITIALIZER-based menu initialization to fix injection context errors
// Menu will now be initialized in AppComponent.ngOnInit() instead

@NgModule({
  imports: [
    BrowserModule,           // 1
    CommonModule,            // 2
    BrowserAnimationsModule, // 3
    AppRoutingModule,        // 4
    RouterModule,            // 5
    AbpOAuthModule.forRoot(), // 6
    CoreModule.forRoot({     // 7
      environment,
      registerLocaleFn: registerLocale(),
    }),
    ThemeSharedModule.forRoot({
      httpErrorConfig: {
        errorScreen: {
          component: ServiceUnavailableComponent,
          forWhichErrors: [0],
          hideCloseIcon: true,
        },
      },
    }),                                           // 8
    AccountConfigModule.forRoot(),               // 9
    IdentityConfigModule.forRoot(),              // 10
    TenantManagementConfigModule.forRoot(),      // 11
    SettingManagementConfigModule.forRoot(),     // 12
    ThemeLeptonXModule.forRoot(),                // 13
    SideMenuLayoutModule.forRoot(),              // 14
    NgxDatatableModule,      // 15
    NgbModule,               // 16
    FormsModule,             // 17
    MatMenuModule,           // 18
    MatButtonModule,         // 19
    MatIconModule,           // 20
    SharedModule             // 21
  ],
  declarations: [AppComponent],
  providers: [
    APP_ROUTE_PROVIDER,
    AppMenuContributor,
    {
      provide: CUSTOM_ERROR_HANDLERS,
      useExisting: BackendUnavailableErrorHandlerService,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {}
